"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _VariationAttributes = _interopRequireDefault(require("../../../../shared/components/VariationAttributes/VariationAttributes"));

var _LineItemDiscounts = _interopRequireDefault(require("../../../../shared/components/LineItemDiscounts/LineItemDiscounts"));

var _AddOns = _interopRequireDefault(require("../AddOns/AddOns"));

var _BonusOrderItem = _interopRequireDefault(require("./BonusOrderItem"));

var _getPriceDisplay2 = _interopRequireDefault(require("../../../../shared/helpers/getPriceDisplay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StandardOrderItem = function StandardOrderItemComponent(_ref) {
  var item = _ref.item;
  var productName = item.productName,
      images = item.images,
      variationAttributes = item.variationAttributes,
      price = item.price,
      quantity = item.quantity,
      linePrice = item.linePrice,
      bonusProducts = item.bonusProducts,
      options = item.options;

  var _getPriceDisplay = (0, _getPriceDisplay2["default"])(price),
      onSale = _getPriceDisplay.onSale,
      salesPriceDisplay = _getPriceDisplay.salesPriceDisplay,
      retailPriceValue = _getPriceDisplay.retailPriceValue;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-items__item-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-items__product-name"
  }, productName), /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-items__product-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-items__product-image"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: images.small[0].url,
    alt: images.small[0].alt
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-items__product-details"
  }, /*#__PURE__*/_react["default"].createElement(_VariationAttributes["default"], {
    customClassNamePrefix: "order-items",
    variationAttributes: variationAttributes
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-items__attribute"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "order-items__attribute-key"
  }, "Item Price"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "order-items__attribute-value"
  }, onSale ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "order-items__product-price-strike"
  }, retailPriceValue), /*#__PURE__*/_react["default"].createElement("span", {
    className: "order-items__product-sale-price"
  }, salesPriceDisplay), /*#__PURE__*/_react["default"].createElement("span", {
    className: "order-items__product-sale-text"
  }, ' on sale')) : salesPriceDisplay)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-items__attribute"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "order-items__attribute-key"
  }, "Quantity"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "order-items__attribute-value"
  }, quantity)), /*#__PURE__*/_react["default"].createElement(_AddOns["default"], {
    options: options
  }))), /*#__PURE__*/_react["default"].createElement(_LineItemDiscounts["default"], {
    className: "order-item__rebate-detail",
    item: item
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-items__total-price"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "order-items__total-price-text"
  }, "Total Price"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "order-items__total-price-value"
  }, linePrice)), bonusProducts.map(function (bonusItem) {
    return /*#__PURE__*/_react["default"].createElement(_BonusOrderItem["default"], {
      key: bonusItem.UUID,
      item: bonusItem
    });
  }));
};

StandardOrderItem.propTypes = {
  item: _propTypes["default"].shape({
    productName: _propTypes["default"].string.isRequired,
    images: _propTypes["default"].shape({
      small: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        url: _propTypes["default"].string.isRequired,
        alt: _propTypes["default"].string.isRequired
      })).isRequired
    }).isRequired,
    variationAttributes: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    price: _propTypes["default"].shape({
      list: _propTypes["default"].shape({
        formatted: _propTypes["default"].string
      }),
      sales: _propTypes["default"].shape({
        formatted: _propTypes["default"].string
      }),
      bonus: _propTypes["default"].shape({
        formatted: _propTypes["default"].string
      })
    }).isRequired,
    quantity: _propTypes["default"].number.isRequired,
    linePrice: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    bonusProducts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      UUID: _propTypes["default"].string
    }))
  }).isRequired
};
var _default = StandardOrderItem;
exports["default"] = _default;